import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Скрываем навбар на главной странице для неавторизованных пользователей
  if (location.pathname === '/' && !user) {
    return null;
  }

  // Скрываем навбар на странице Dashboard (там своя навигация)
  if (location.pathname === '/dashboard') {
    return null;
  }

  // Скрываем навбар на админ-панели
  if (location.pathname === '/admin' || location.pathname.startsWith('/admin/')) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          NaixVPN
        </Link>
        <div className="navbar-menu">
          {user ? (
            <>
              <span className="navbar-user">Привет, {user.name}!</span>
              <button onClick={handleLogout} className="navbar-button">
                Выйти
              </button>
            </>
          ) : (
            <>
              <Link to="/register" className="navbar-button">
                Регистрация
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

